import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { QuoteForm } from './components/QuoteForm';
import { EmailPopup } from './components/EmailPopup';
import { PastQuotes } from './components/PastQuotes';
import { callWFAPI } from './utils/helper';
const getPriceType = async (email: string) => {
  const data = {
    filters: [{
      field: 'email',
      value: email.toLowerCase()
    }],
    getfields: 'id',
    count: 1
  };
  try {
    const res = await callWFAPI(26810, 'findMembers', data);
    if (res.length > 0 && res[0].group_id == 1932045) {
      return 'wholesale';
    }
  } catch (error) {
    alert(error.message);
  }
  return 'retail';
};
const loadPastQuotes = async (email: string) => {
  localStorage.setItem('my_quotes', '');
  const data = {
    appname: 'tkd-score',
    reportname: 'Daedo_Gen_3_Purchase_Quote_Report',
    criteria: '(Email == "' + email.toLowerCase() + '")'
  };
  try {
    const res = await callWFAPI(0, 'zohoCreator', data);
    if (res.length > 0) {
      let quotes = [];
      for (let i = 0; i < res.length; i++) {
        let shipAddress = res[i].Shipping_Address || '';
        shipAddress = shipAddress.split('\n');
        let quote = {
          id: res[i].ID,
          date: res[i].added,
          total: res[i].total,
          priceType: res[i].price_type,
          customer: {
            email: res[i].Email,
            name: res[i].Name,
            phone: res[i].Phone_Number,
            state: res[i].State,
            address: shipAddress[0],
            city: shipAddress.length == 3 || shipAddress.length == 2 && shipAddress[1].indexOf('city') === 0 ? shipAddress[1].replace('city: ', '') : '',
            zip: shipAddress.length == 3 ? shipAddress[2].replace('zip: ', '') : shipAddress.length == 2 && shipAddress[1].indexOf('zip') === 0 ? shipAddress[1].replace('zip: ', '') : ''
          },
          cart: {}
        };
        let products = res[i].Products.split('\n');
        for (let i = 0; i < products.length; i++) {
          let m = products[i].match(/^(.+):\s+(\d+)$/);
          if (m) {
            quote.cart[m[1]] = m[2];
          }
        }
        quotes.push(quote);
      }
      localStorage.setItem('my_quotes', JSON.stringify(quotes));
    }
  } catch (error) {
    alert(error.message);
  }
};
export function App() {
  const [userEmail, setUserEmail] = useState('');
  const [showEmailPopup, setShowEmailPopup] = useState(true);
  const [showPastQuotes, setShowPastQuotes] = useState(false);
  const [priceType, setPriceType] = useState('retail');
  const [isLoadingFromId, setIsLoadingFromId] = useState(false);
  const [autoSelectQuoteId, setAutoSelectQuoteId] = useState(null);
  const processEmail = async (email: string) => {
    const determinedPriceType = await getPriceType(email);
    await loadPastQuotes(email);
    return determinedPriceType;
  };
  const getEmailByID = async (id: string) => {
    const params = {
      appname: 'tkd-score',
      reportname: 'Daedo_Gen_3_Purchase_Quote_Report',
      criteria: '(ID == ' + id + ')'
    };
    const resp = await callWFAPI(0, 'zohoCreator', params);
    if (resp.length > 0) {
      const email = resp[0]['Email'];
      const determinedPriceType = await processEmail(email);
      handleEmailSubmit(email, determinedPriceType);
      setShowPastQuotes(true);
      setAutoSelectQuoteId(id);
    }
  };
  useEffect(() => {
    const checkUrlParams = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id');
      if (id) {
        setIsLoadingFromId(true);
        try {
          await getEmailByID(id);
        } catch (error) {
          console.error('Error loading email by ID:', error);
        } finally {
          setIsLoadingFromId(false);
        }
      }
    };
    checkUrlParams();
  }, []);
  const handleEmailSubmit = (email: string, determinedPriceType: string) => {
    setUserEmail(email);
    setPriceType(determinedPriceType);
    setShowEmailPopup(false);
  };
  return <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-orange-600" data-id="element-0">
      <EmailPopup isOpen={showEmailPopup} onSubmit={handleEmailSubmit} isLoadingFromId={isLoadingFromId} processEmail={processEmail} data-id="element-1" />
      <div className="container mx-auto px-4 py-8" data-id="element-2">
        <HeroSection currentPriceType={priceType} data-id="element-3" />
        {!showEmailPopup && <>
            <div className="flex justify-end mb-4" data-id="element-4">
              <button onClick={() => setShowPastQuotes(!showPastQuotes)} className="bg-white text-blue-600 px-4 py-2 rounded-md font-semibold hover:bg-gray-100 shadow-md" data-id="element-5">
                {showPastQuotes ? 'Back to Quote Builder' : 'Past Quotes'}
              </button>
            </div>
            {showPastQuotes ? <PastQuotes userEmail={userEmail} priceType={priceType} autoSelectQuoteId={autoSelectQuoteId} onQuoteSelected={() => setAutoSelectQuoteId(null)} data-id="element-6" /> : <QuoteForm initialEmail={userEmail} priceType={priceType} data-id="element-7" />}
          </>}
      </div>
    </div>;
}